import React from 'react'
import { Modal } from 'react-bootstrap'
import { GoogleAnalyticsEnum, pageView, triggerFunction } from '../../utils/google-analytics'
import Testimonial from './Testimonial';

export const TestimonialForm = ({ data, show, onCloseModal, title = "Form", type }) => {
    return (
        <>
            {pageView(window.location.href, GoogleAnalyticsEnum.TESTIMONIAL_FORM_OPENED)}
            <div>
                <Modal className="rounded-lg" show={show} onHide={() => { onCloseModal(); triggerFunction(window.location.href + GoogleAnalyticsEnum.BUTTON, GoogleAnalyticsEnum.TESTIMONIAL_FORM_CLOSED) }} aria-labelledby="contained-modal-title-vcenter" centered size="lg">
                    <Modal.Header closeButton className="px-5 pb-0 border-0">
                        <Modal.Title as={'h5'} className="mb-0" >{title}</Modal.Title>
                    </Modal.Header>
                    <Modal.Body className="px-5 pb-4">
                        {/* <div class="hs-form-frame" data-region="na2" data-form-id="3ab0326f-0f35-44cf-8a90-0efb382ed613" data-portal-id="242859014"></div> */}
                        <Testimonial data={data} closeForm={onCloseModal && onCloseModal} type={type} />
                    </Modal.Body>
                </Modal>
            </div>
        </>
    )
}
